
try {} catch (e) { let Nunalie = Nunalie || {}; }

Nunalie.redirect = {
  dev_mode: false,
  store1Countries : "IT",
  store2Countries : "AT,BE,BG,CY,HR,DK,EE,FI,FR,DE,GB,EL,IE,LV,LT,LU,MT,NL,PL,PT,CZ,SK,RO,SI,SE,HU,ES",
  store3Countries : "CH",
  store4Countries : "",
  allCountry : [],
  countryList : [
    
    { name: "Isole Åland", code: "AX", currency: "EUR" },
    { name: "Albania", code: "AL", currency: "EUR" },
    
    
    { name: "Andorra", code: "AD", currency: "EUR"},
    
    
    
    
    
    { name: "Armenia", code: "AM", currency: "EUR" },
    
    
    { name: "Austria", code: "AT", currency: "EUR" },
    
    
    
    
    
    { name: "Bielorussa", code: "BY", currency: "EUR" },
    { name: "Belgio", code: "BE", currency: "EUR" },
    
    
    
    
    
    { name: "Bosnia Erzegovina", code: "BA", currency: "EUR" },
    
    
    
    
    
    { name: "Bulgaria", code: "BG", currency: "EUR"},
    
    
    
    
    { name: "Canada", code: "CA", currency: "USD"},
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Croazia", code: "HR", currency: "EUR" },
    
    
    { name: "Repubblica Ceca", code: "CZ", currency: "EUR"  },
    { name: "Danimarca", code: "DK", currency: "EUR"  },
    
    
    
    
    
    
    
    
    { name: "Estonia", code: "EE", currency: "EUR"},
    
    
    
    
    { name: "Finlandia", code: "FI", currency: "EUR"},
    { name: "Francia", code: "FR", currency: "EUR" },
    
    
    
    
    
    { name: "Georgia", code: "GE", currency: "EUR"},
    { name: "Germania", code: "DE", currency: "EUR" },
    
    
    { name: "Grecia", code: "GR", currency: "EUR"},
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Ungaria", code: "HU", currency: "EUR"},
    { name: "Islanda", code: "IS", currency: "EUR"},
    
    
    
    
    { name: "Irlanda", code: "IE", currency: "EUR"},
    
    
    { name: "Italia", code: "IT", currency: "EUR"},
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Liechtenstein", code: "LI", currency: "EUR" },
    { name: "Lithuania", code: "LT", currency: "EUR" },
    { name: "Luxembourg", code: "LU", currency: "EUR" },
    
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK", currency: "EUR" },
    
    
    
    
    
    { name: "Malta", code: "MT", currency: "EUR" },
    
    
    
    
    
    
    
    { name: "Moldavia", code: "MD", currency: "EUR" },
    { name: "Monaco", code: "MC", currency: "EUR" },
    
    { name: "Montenegro", code: "ME", currency: "EUR" },
    
    
    
    
    
    
    
    { name: "Olanda", code: "NL", currency: "EUR" },
    
    
    
    
    
    
    
    
    
    { name: "Norvegia", code: "NO", currency: "EUR" },
    
    
    
    
    
    
    
    
    
    
    { name: "Polonia", code: "PL", currency: "EUR" },
    { name: "Portogallo", code: "PT", currency: "EUR" },
    
    
    
    { name: "Romania", code: "RO", currency: "EUR" },
    { name: "Federazione Russa", code: "RU", currency: "EUR" },
    
    
    
    
    
    
    
    { name: "San Marino", code: "SM", currency: "EUR" },
    
    
    
    { name: "Serbia", code: "RS", currency: "EUR" },
    
    
    
    { name: "Slovacchia", code: "SK", currency: "EUR" },
    { name: "Slovenia", code: "SI", currency: "EUR" },
    
    
    
    
    { name: "Spagna", code: "ES", currency: "EUR" },
    
    
    
    
    
    { name: "Svezia", code: "SE", currency: "EUR" },
    { name: "Svizzera", code: "CH", currency: "CHF" },
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Ucraina", code: "UA", currency: "EUR" },
    
    { name: "Regno Unito", code: "GB", currency: "GBP" },
    { name: "Stati Uniti", code: "US", currency: "USD" },
    
    
    
    
    
  ],
  countryListEN : [
    
    { name: "land Islands", code: "AX", currency: "EUR" },
    { name: "Albania", code: "AL", currency: "EUR" },
    
    
    { name: "Andorra", code: "AD", currency: "EUR"},
    
    
    
    
    
    { name: "Armenia", code: "AM", currency: "EUR" },
    
    
    { name: "Austria", code: "AT", currency: "EUR" },
    
    
    
    
    
    { name: "Belarus", code: "BY", currency: "EUR" },
    { name: "Belgium", code: "BE", currency: "EUR" },
    
    
    
    
    
    { name: "Bosnia and Herzegovina", code: "BA", currency: "EUR" },
    
    
    
    
    
    { name: "Bulgaria", code: "BG", currency: "EUR"},
    
    
    
    
    { name: "Canada", code: "CA", currency: "USD"},
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Croatia", code: "HR", currency: "EUR" },
    
    
    { name: "Czech Republic", code: "CZ", currency: "EUR"  },
    { name: "Denmark", code: "DK", currency: "EUR"  },
    
    
    
    
    
    
    
    
    { name: "Estonia", code: "EE", currency: "EUR"},
    
    
    
    
    { name: "Finland", code: "FI", currency: "EUR"},
    { name: "France", code: "FR", currency: "EUR" },
    
    
    
    
    
    { name: "Georgia", code: "GE", currency: "EUR"},
    { name: "Germany", code: "DE", currency: "EUR" },
    
    
    { name: "Greece", code: "GR", currency: "EUR"},
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Hungary", code: "HU", currency: "EUR"},
    { name: "Iceland", code: "IS", currency: "EUR"},
    
    
    
    
    { name: "Ireland", code: "IE", currency: "EUR"},
    
    
    { name: "Italy", code: "IT", currency: "EUR"},
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Liechtenstein", code: "LI", currency: "EUR" },
    { name: "Lithuania", code: "LT", currency: "EUR" },
    { name: "Luxembourg", code: "LU", currency: "EUR" },
    
    { name: "Macedonia, The Former Yugoslav Republic of", code: "MK", currency: "EUR" },
    
    
    
    
    
    { name: "Malta", code: "MT", currency: "EUR" },
    
    
    
    
    
    
    
    { name: "Moldova, Republic of", code: "MD", currency: "EUR" },
    { name: "Monaco", code: "MC", currency: "EUR" },
    
    { name: "Montenegro", code: "ME", currency: "EUR" },
    
    
    
    
    
    
    
    { name: "Netherlands", code: "NL", currency: "EUR" },
    
    
    
    
    
    
    
    
    
    { name: "Norway", code: "NO", currency: "EUR" },
    
    
    
    
    
    
    
    
    
    
    { name: "Poland", code: "PL", currency: "EUR" },
    { name: "Portugal", code: "PT", currency: "EUR" },
    
    
    
    { name: "Romania", code: "RO", currency: "EUR" },
    { name: "Russian Federation", code: "RU", currency: "EUR" },
    
    
    
    
    
    
    
    { name: "San Marino", code: "SM", currency: "EUR" },
    
    
    
    { name: "Serbia", code: "RS", currency: "EUR" },
    
    
    
    { name: "Slovakia", code: "SK", currency: "EUR" },
    { name: "Slovenia", code: "SI", currency: "EUR" },
    
    
    
    
    { name: "Spain", code: "ES", currency: "EUR" },
    
    
    
    
    
    { name: "Sweden", code: "SE", currency: "EUR" },
    { name: "Switzerland", code: "CH", currency: "CHF" },
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    
    { name: "Ukraine", code: "UA", currency: "EUR" },
    
    { name: "United Kingdom", code: "GB", currency: "GBP" },
    { name: "United States", code: "US", currency: "USD" },
    
    
    
    
    
  ],
  currentCountryList: [],
  allCurrency : [],
  currencyList : [
    { name: "Euro", code: "EUR" },
    { name: "Swiss franc", code: "CHF" }
  ],
  languageList: [
    {code: 'IT', name:'Italian'},
    {code: 'EN', name:'English'}
  ],
  popupElement: '#banner-redirect',
  popupOverlay: '#banner-overlay',
  popupRedirectSelector : ".banner-redirect",
  popupRedirectCloseSelector : ".banner-redirect__close",
  popupRedirectComponents : ".banner-redirect__components",
  popupRedirectAlertSelector : ".banner-redirect__alert",
  popupRedirectAlertTextSelector : ".banner-redirect__alert-text",
  countrySelectSelector : ".banner-redirect__countries",
  countrySelectSelectorFooter : ".country-selector",
  userCountry : null,
  countrySelect : null,
  currencySelect: null,
  currentStoreUrl : window.routes.shop_url,
  store1Url:"https:\/\/nunalie.it",
  store2Url:"https:\/\/nunalie.eu",
  store3Url:"https:\/\/nunalie.ch",
  store4Url:"",
  country_at : null,

  isCustomize: function () {
    let isCustomizing = false;
    if (window.location !== window.parent.location) {
      isCustomizing = true;
    }
    return isCustomizing;
  },

  getUrlVars: function () {
    let vars = [],
      hash;
    let hashes = window.location.href
      .slice(window.location.href.indexOf("?") + 1)
      .split("&");

      if(this.dev_mode)console.log(hashes);

      for (let i = 0; i < hashes.length; i++) {
      hash = hashes[i].split("=");

      if(this.dev_mode) { console.log("hash: " + hash); console.log("hash[1]: " + hash[1]); }

      vars.push(hash[0]);
      vars[hash[0]] = hash[1];
    }
    if(this.dev_mode){ console.log("vars"); console.log(vars); }

    return vars;
  },

  startRedirectFlow: function () {
    let self = this;
    let urlVars = this.getUrlVars();
    let alertText = null;

    if(this.dev_mode)console.log("urlVars");

    if (urlVars["redirect"] == "true") {
      if(this.dev_mode){ console.log("redirect true"); console.log("current URL: " + this.currentStoreUrl); }

      Nunalie.createCookie("countryRedirectN", this.currentStoreUrl, 60);
      if (urlVars["shippingCountry"]) {
        Nunalie.createCookie("countryN", urlVars["shippingCountry"], 60);
      }
      if (urlVars["currency"]) {
        Nunalie.createCookie("CurrencySJ", urlVars["currency"], 60);
      }
    }

    
    if (Nunalie.getCookieValue("countryN") && Nunalie.getCookieValue("countryRedirectN")) {
      let url = Nunalie.getCookieValue("countryRedirectN");
      if(this.dev_mode)console.log("url cookie: " + url);
      
      let code = Nunalie.getCookieValue("countryN");
      let country = this.allCountry.filter(function (country) {
        return country.code == code;
      });
      let currency = Nunalie.getCookieValue("CurrencySJ");
      if(this.dev_mode){ console.log(country);console.log(currency);}

      if (url && url == this.currentStoreUrl) {
        
      } else if (url && url != this.currentStoreUrl && !url.includes("shopifypreview")) {
        if(this.dev_mode) {console.log("url to perform: " + url);console.log("performRedirect"); }
        this.performRedirect(url, code, country, currency);
      }
    } else {
      
      if(!Nunalie.getCookieValue("countryN")){
        document.querySelector(this.popupOverlay).style.display="block";
        document.querySelector(this.popupElement).style.display="block";
        document.body.classList.add('overflow-hidden');
      }
      
      fetch('//www.cloudflare.com/cdn-cgi/trace', {mode: 'cors'})
      .then(response => response.text())
      .then(data => {
        let countryCodeData = data.replace(/(\r\n|\n|\r)/gm,"").split('loc=');
        countryCodeData = countryCodeData[1].split('tls=');
        country_code = countryCodeData[0];
        const locale = Shopify.locale;
        
        
        if(self.dev_mode)console.log("success ajax");

          let country = self.allCountry.filter(function (country) {
            return country.code == country_code;
          });
          let jsonCountry = self.currentCountryList.filter(function (country) {
            return country.code == country_code;
          });
          let currentStores = self.allCountry.filter(function (country) {
            return country.url == self.currentStoreUrl;
          });
          let url = Nunalie.getCookieValue("countryRedirectN");
          if(self.dev_mode){console.log("country: "+JSON.stringify(country));console.log("jsonCountry: "+JSON.stringify(jsonCountry));console.log("currentStoresUrl: "+JSON.stringify(currentStores)); }

          
          let alertText = document.querySelector(self.popupRedirectAlertTextSelector)
            .innerText
            .replace(/\$nation/gi, jsonCountry[0].name);
            document.querySelector(self.popupRedirectAlertTextSelector).innerText = alertText;

          
          self.userCountry = country;
          Nunalie.createCookie("realcountryN", country_code);
          if (urlVars["shippingCountry"]) {
            Nunalie.createCookie("countryN", urlVars["shippingCountry"], {
              expires: 60,
            });
            Nunalie.createCookie("countryRedirectN", self.currentStoreUrl, {
              expires: 60,
            });
          } else if (
            Nunalie.getCookieValue("countryN") == null ||
            Nunalie.getCookieValue("countryN") != country_code
          ) {
            Nunalie.createCookie("countryN", country_code, 60);
          }
          const countriesSelector = document.querySelector(self.countrySelectSelector);
          
          countriesSelector.value = countriesSelector.querySelector('option[data-iso="' + Nunalie.getCookieValue("countryN") + '"]').value;

          
          const eventChangeSelect = new Event('change.select');
          document.dispatchEvent(eventChangeSelect);

          
          const countrySelectorElements = document.querySelectorAll(self.countrySelectSelectorFooter)
          
          Array.from(countrySelectorElements).forEach(element => {
            element.value = Nunalie.getCookieValue("countryN");
            element.options[element.selectedIndex].defaultSelected = true;
            // element.options[element.selectedIndex].innerText = Nunalie.getCookieValue("countryN");
          });

          if (url && url == self.currentStoreUrl) {
            if(self.dev_mode)console.log("same url of this");
            
          } else if (url && url != self.currentStoreUrl) {
            if(self.dev_mode)console.log("not same url");
            window.location.replace(url);
          } else if (country[0].url == self.currentStoreUrl) {
            if(self.dev_mode)console.log("set url cookie temporary");
            Nunalie.createCookie("countryRedirectN", self.currentStoreUrl, {
              expires: 60,
            });
          } else {
            if(self.dev_mode)console.log("popup components active");
          }
        })
        .catch((error) => {
          console.error('Error:', error);
        })
    }
  },

  _addEventHandler: function (){
    const self = this;
    let currencySelected = null;

    
    
    document.querySelectorAll(self.countrySelectSelectorFooter).forEach(function(element) {
      element.addEventListener('change', function() {
        if(self.dev_mode) {console.log("change selector");console.log(selector);}

        let code = this.options[this.selectedIndex].getAttribute("data-iso");
        let currency = this.options[this.selectedIndex].getAttribute("data-iso-currency");
        let country = self.allCountry.filter(function (country) {
            return country.code == code;
        });

        if(self.dev_mode)console.log(code);

        Nunalie.createCookie("countryN", country[0].code, 60);
        Nunalie.createCookie("countryRedirectN", country[0].url, 60);
        Nunalie.createCookie("CurrencySJ", currency, 60);
        let pathName = window.location.pathname;

        if(self.dev_mode){console.log("country[0]");console.log(country[0]);}

        let redirectUrl = country[0].url + pathName;

        
         self.performRedirect(redirectUrl, code, country, currency);
      });

    })

    document.querySelector(this.popupOverlay).addEventListener('click', function (event) {
      self.closePopup();
    });

    document.querySelector("#close").addEventListener('click', function (event) {
      self.closePopup();
    });

    if(this.dev_mode)console.log(this.countrySelect);

    document.querySelector(".banner-redirect__button").addEventListener("click", function (e) {
      if(self.dev_mode)console.log("click button");
      e.preventDefault();
      
      const countriesSelector = document.querySelector(self.countrySelectSelector)
      let code = countriesSelector.options[countriesSelector.selectedIndex].getAttribute("data-iso");
      let currency =  countriesSelector.options[countriesSelector.selectedIndex].getAttribute("data-iso-currency");
      let country = self.allCountry.filter(function (country) {
        return country.code == code;
      });
      if(self.dev_mode)console.log(country[0].code);
      
      Nunalie.createCookie("countryN", country[0].code, 60);
      Nunalie.createCookie("countryRedirectN", country[0].url, 60);
      let pathName = window.location.pathname;
      if(self.dev_mode){console.log("country[0]");console.log(country[0]);}

      let redirectUrl = country[0].url + pathName;

      
      self.performRedirect(redirectUrl, code, country, currency);
    });
  },

  closePopup: function() {
    document.querySelector(this.popupOverlay).style.display="none";
    document.querySelector(this.popupElement).style.display="none";
    document.body.classList.remove('overflow-hidden');
  },

  performRedirect: function (url, code, country, currency) {
    if(this.dev_mode){console.log("performRedirect: "+url);console.log("performRedirect: "+code);console.log("currency: "+currency);}

    let xhttp = new XMLHttpRequest();
    xhttp.onreadystatechange = function () {
      if (this.readyState == 4) {
        if (this.status == 200) {
          if(this.dev_mode)console.log("success url: "+url);
          window.location.replace(
            url + "?redirect=true&shippingCountry=" + code + "&currency=" + currency
          );
        } else {
          if(this.dev_mode)console.log("fail url: "+url);
          window.location.replace(
            country[0].url + "?redirect=true&shippingCountry=" + code + "&currency=" + currency
          );
        }
      }
    };
    xhttp.open("GET", url, true);
    xhttp.send();
  },

  init: function () {

    this.currentCountryList = Shopify.locale == 'it' ? this.countryList : this.countryListEN;
    if(this.dev_mode){console.log(this.currentStoreUrl);console.log(this.store1Url);console.log(this.store1Countries);}

    this.store1Countries = this.store1Countries ? this.store1Countries.replace(/\s/g, "").split(",") : null;
    this.store2Countries = this.store2Countries ? this.store2Countries.replace(/\s/g, "").split(",") : null;
    this.store3Countries = this.store3Countries ? this.store3Countries.replace(/\s/g, "").split(",") : null;
    this.store4Countries = this.store4Countries ? this.store4Countries.replace(/\s/g, "").split(",") : null;
    
    if(this.dev_mode){console.log(this.store1Countries);console.log(this.store2Countries);console.log(this.store3Countries);console.log(this.store4Countries);}
    
    if (this.store1Countries) {
        for (let i = 0; i < this.store1Countries.length; i++) {
          this.allCountry.push({
            store: "1",
            code: this.store1Countries[i],
            url: this.store1Url,
          });
        }
    }
    if (this.store2Countries) {
      for (let i = 0; i < this.store2Countries.length; i++) {
        this.allCountry.push({
          store: "2",
          code: this.store2Countries[i],
          url: this.store2Url,
        });
      }
    }
    if (this.store3Countries) {
      for (let i = 0; i < this.store3Countries.length; i++) {
        this.allCountry.push({
          store: "3",
          code: this.store3Countries[i],
          url: this.store3Url,
        });
      }
    }
    if (this.store4Countries) {
      for (let i = 0; i < this.store4Countries.length; i++) {
        this.allCountry.push({
          store: "4",
          code: this.store4Countries[i],
          url: this.store4Url,
        });
      }
    }
    if(this.dev_mode){console.log("All country: ");console.log(this.allCountry);}

    for (let i = 0; i < this.currentCountryList.length; i++) {
      country_at = this.currentCountryList[i].code;
      let _country = this.allCountry.filter(function (country) {
        return country.code == country_at;
      });
      if (_country[0]) {
        
          const option = document.createElement("option");
          option.setAttribute("data-href", _country[0].url);
          option.setAttribute("data-name", this.currentCountryList[i].name);
          option.setAttribute("data-iso", this.currentCountryList[i].code);
          option.setAttribute("data-iso-currency", this.currentCountryList[i].currency);
          option.value = this.currentCountryList[i].code;
          option.text = this.currentCountryList[i].name;

          document.querySelector(this.countrySelectSelector).appendChild(option);
          
          // selector options (header,footer)
          const optionCloneFooter = option.cloneNode(true);
          const optionCloneHeader = option.cloneNode(true);
          document.querySelector('footer ' +  this.countrySelectSelectorFooter).appendChild(optionCloneFooter);
          if(document.querySelector('header ' +  this.countrySelectSelectorFooter))
          document.querySelector('header ' +  this.countrySelectSelectorFooter).appendChild(optionCloneHeader);
      }
    }
    this.startRedirectFlow();
  },
};

if(!Nunalie.redirect.isCustomize()) {
  Nunalie.redirect.init();
  Nunalie.redirect._addEventHandler();
}


document.addEventListener("DOMContentLoaded", function() {

  const countrySelectors = document.querySelectorAll('.country-selector');

  Array.from(countrySelectors).forEach(element => {
    element.style.display = 'block';
    element.value = Nunalie.getCookieValue("countryN");
    element.options[element.selectedIndex].defaultSelected = true;

    element.addEventListener('change', function() {
        this.options[0].value = this.options[this.selectedIndex].value;
        this.options[0].innerHTML = this.options[this.selectedIndex].innerHTML;
        this.value = this.options[this.selectedIndex].value;
        this.querySelector("option[value=" + this.options[this.selectedIndex].value + "]");
    });
  });

});